<template>
    <v-container>
        <v-row>
            <v-dialog v-model="showDialog" max-width="600">
                <v-card>
                    <v-system-bar flat color="white">
                        <v-spacer></v-spacer>
                        <v-btn text class="mt-3" style="color:#B45C5C" @click="showDialog=false">Close <v-icon small right>mdi-close</v-icon></v-btn>
                    </v-system-bar>
                    <v-card-text class="text-center headline mt-6" style="color:#48c074;">Transaction Details</v-card-text>
                    <v-card-text>
                    <v-simple-table>
                        <template v-slot:default>
                        <thead>
                            <tr>
                            <th class="text-center black--text">Attribute</th>
                            <th class="text-center black--text">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-center">Amount</td>
                                <td class="text-center">&#8358;{{showTrans.amount}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Estimated Return</td>
                                <td class="text-center">&#8358;{{showTrans.estimated_return}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Investment Code</td>
                                <td class="text-center">{{showTrans.investment_code}}</td>
                            </tr>
                            
                            <tr>
                                <td class="text-center">Units Bought</td>
                                <td class="text-center">{{showTrans.units_bought}}</td>
                            </tr>
                            
                            <tr>
                                <td class="text-center">Payment Ref</td>
                                <td class="text-center">{{showTrans.transRef}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Status</td>
                                <td class="text-center">{{showTrans.status}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Date Paid</td>
                                <td class="text-center">{{showTrans.date_paid}}</td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    
                    
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <h3 class="mt-7">Dashboard</h3>
        <v-row>
            <v-col cols="12" md="3" sm="6">
               
                
                <!-- <v-divider></v-divider> -->
                <v-card class="pa-4">
                    <div class="text-center my-3">
                        <v-progress-circular
                            :value="100"
                            color="teal"
                            :size="90"
                            :width="7"
                        >{{Investment.length}}</v-progress-circular> 
                        <span class="ml-3">Your Farms</span>
                    </div>
                    <div class="text-center my-3">
                        <!-- <v-subheader >
                            Last Added: 2020-05-07
                        </v-subheader> -->
                    </div>
                    

                </v-card>
                <v-divider></v-divider>
                <v-card class="pa-4 mt-3" >
                   
                    <div class="text-center my-3">
                        <v-progress-circular
                            :value="100"
                            color="purple"
                            :size="90"
                            :width="7"
                        >{{Transactions.length}}</v-progress-circular>
                        <span class="ml-3">Transactions</span>
                    </div>
                    <!-- <v-divider class="ma-0"></v-divider>
                    <v-row>
                        <v-col class="pa-0">
                            <v-card-text class="text-center px-0 pb-0">
                            <v-icon color="green">mdi-check</v-icon>
                            <h3 style="color:green">0</h3>
                            </v-card-text>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col class="pa-0">
                        <v-card-text class="text-center px-0 pb-0">
                            <v-icon color="red">mdi-close</v-icon>
                            <h3 style="color:red">0</h3>
                            </v-card-text>
                        </v-col>
                    </v-row>
                     -->

                </v-card>
                
                
            </v-col>
            <v-col cols="12" md="9" sm="6">
               <v-row no-gutters>
                   <v-col>
                        <v-card>
                            <v-card-title style="color:#48c074">
                                My Investments
                            </v-card-title>
                            <v-data-table
                            :headers="headers"
                            :items="Investment"
                            
                            no-data-text='You have no current investments'
                            >
                            <template v-slot:item.action="{ item }">
                                <v-btn text @click="getInvestById($event, item._id)" style="border: 1px #48c074 solid; color:#48c074" class="text-none" small>View</v-btn>
                            </template>
                            <template v-slot:item.amount_paid="{ item }">
                                    
                                    <span class="black--text">&#8358;{{item.amount_paid}}</span>
                                </template>
                                <template v-slot:item.roi="{ item }">
                                    
                                    <span class="black--text">{{item.roi}}%</span>
                                </template>
                            </v-data-table>
                        </v-card>
                   </v-col>
               </v-row>
               <v-row class="mt-3">
                   <v-col>
                        <v-card>
                            <v-card-title style="color:#48c074">
                                Recent Transactions
                            </v-card-title>
                            <v-data-table
                                :headers="transHeaders"
                                :items="Transactions"
                                hide-default-footer=""
                                :items-per-page="5"
                                no-data-text='No Recent Transaction For Display'
                                >
                                <template v-slot:item.estimated_return="{ item }">
                                    <span class="black--text">&#8358;{{item.estimated_return}}</span>
                                </template>
                                <template v-slot:item.desc="{ item }">
                                    <span class="black--text">{{item.description}}</span>
                                </template>
                                <template v-slot:item.type="{ item }">
                                    <span class="black--text">{{item.paymentType}}</span>
                                </template>
                                <template v-slot:item.date="{ item }">
                                    <span class="black--text">{{item.datePerformed}}</span>
                                </template>
                                <template v-slot:item.amount="{ item }">
                                    
                                    <span class="black--text">&#8358;{{item.amount}}</span>
                                </template>
                                <template v-slot:item.estimated_return="{ item }">
                                    
                                    <span class="black--text">&#8358;{{item.estimated_return}}</span>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-btn text @click="show(item)" style="border: 1px #48c074 solid; color:#48c074" class="text-none" small>View</v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                   </v-col>
                </v-row>
                
            </v-col>
            
            
      </v-row>
    </v-container>
</template>

<script>
    export default {
        components:{
            
        },
        data(){
            return{
                date:new Date().toISOString().substr(0, 10),
                headers: [
                    {
                    text: 'Farm',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                    },
                    { text: 'Amount Paid', value: 'amount_paid' },
                    { text: 'ROI', value: 'roi' },
                    { text: 'Duration', value: 'duration' },
                    { text: 'Date Added', value: 'date_created' },
                    { text: '', value: 'action' },
                ],
                transHeaders: [
                    {
                        text: 'Amount',
                        align: 'start',
                        sortable: false,
                        value: 'amount',
                    },
                    { text: 'Status', value: 'status' },
                    { text: 'Estimated Return', value: 'estimated_return' },
                    { text: 'Date Paid', value: 'date_paid' },
                    { text: '', value: 'action' },
                    
                
                
                ],
                trans:[
                    {amount:'90,000', description:'Investment Payment', status:'Sucessful', trans_type:'Wallet Top Up', date_performed:'2020-09-08 08:15:03'}
                ],
                showDialog:false,
                showTrans:{},
                investments:[
                    {name:'Poultry', duration:'3 months', cost:'90,000', roi:'30%', status:'Invested', date_created:'2020-09-08 09:30:01'}
                ]
                
                
            }
        },
        computed:{
            Investment(){
                 let user= this.$store.state.farm.investment
                for(let i=0; i<user.length; i++){
                    user[i].date_created = user[i].date_created.slice(0, 19).replace('T', ' ')
                    user[i].amount_paid = parseFloat(user[i].amount_paid).toFixed(2)
                    user[i].amount_paid = user[i].amount_paid.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
              return user
            },
             Transactions(){
                let transact = this.$store.state.farm.transactions
                 for(let i=0; i<transact.length; i++){
                    transact[i].date_paid = transact[i].date_paid.slice(0, 19).replace('T', ' ')
                    transact[i].amount = parseFloat(transact[i].amount).toFixed(2)
                    transact[i].amount = transact[i].amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    transact[i].estimated_return = parseFloat(transact[i].estimated_return).toFixed(2)
                    transact[i].estimated_return = transact[i].estimated_return.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                return transact
            }
        },
        created(){
            
            this.$store.dispatch("GetUsersInvestment",{id:this.$store.state.auth.logindetails.data._id})
            .then(()=>{ 
            })
            .catch(()=>{
            });

            this.$store.dispatch("GetTransactions",{id:this.$store.state.auth.logindetails.data._id})
            .then(()=>{ 
            })
            .catch(()=>{
            });

            
        }, 
        methods:{
            getAppById(id){ 
                this.$store.dispatch("GetAppById",id)
                .then(()=>{      
                    this.$router.push('applications/'+id)
                })
                .catch(()=>{
                });
                
            },
            show(item){
                this.showTrans=item
                this.showDialog=true
            },
            getInvestById(event, item){
                event.preventDefault()
                 this.$store.dispatch("GetInvestmentById", item)
                .then(()=>{     
                    this.$router.push('/invest/'+item)
                })
                .catch(()=>{
                });
               
            }
        }   
        
    }
</script>

<style>

</style>